// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   ENTERPRISE DOCUMENTS & FILE VAULT STYLING
   Theme: Precision Clean SaaS (Linear / Stripe / Vercel style)
   ========================================================================== */

/* ── Hero / Overview Header ────────────────────────────────────────────── */
.docs-hero-bar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.docs-hero-left {
    flex: 1 1;
    min-width: 280px;
}

.docs-badge-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: #eef2ff;
    color: #4f46e5;
    border: 1px solid #c7d2fe;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

.docs-hero-title {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 24px;
    font-weight: 800;
    color: #0f172a;
    margin: 0 0 6px 0;
    letter-spacing: -0.5px;
}

.docs-hero-subtitle {
    font-size: 13px;
    color: #64748b;
    margin: 0 0 12px 0;
    max-width: 600px;
    line-height: 1.5;
}

.docs-meta-chips {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.docs-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 600;
    color: #475569;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.docs-chip i {
    font-size: 12px;
    color: #6366f1;
}

.docs-chip-secure {
    background: #ecfdf5;
    border-color: #a7f3d0;
    color: #065f46;
}

/* ── Hero Actions ──────────────────────────────────────────────────────── */
.docs-hero-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.btn-docs-action {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #ffffff;
    color: #334155;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.btn-docs-action:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    color: #0f172a;
    transform: translateY(-1px);
}

/* ── Executive KPI Cards Grid ──────────────────────────────────────────── */
.docs-kpi-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
}

.doc-kpi-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 18px 20px;
    display: flex;
    flex-direction: column;
    position: relative;
    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);
    transition: all 0.25s ease;
}

.doc-kpi-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px -4px rgba(15, 23, 42, 0.08);
    border-color: #cbd5e1;
}

.doc-kpi-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.doc-kpi-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #64748b;
}

.doc-kpi-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
}

.doc-icon-indigo  { background: #eef2ff; color: #4f46e5; }
.doc-icon-rose    { background: #fff1f2; color: #f43f5e; }
.doc-icon-emerald { background: #ecfdf5; color: #10b981; }
.doc-icon-sky     { background: #f0f9ff; color: #0284c7; }

.doc-kpi-main {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 8px;
}

.doc-kpi-val {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 24px;
    font-weight: 800;
    color: #0f172a;
    line-height: 1.1;
}

.doc-kpi-tag {
    font-size: 11px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 6px;
}

.tag-indigo  { background: #eef2ff; color: #3730a3; }
.tag-rose    { background: #fff1f2; color: #9f1239; }
.tag-emerald { background: #ecfdf5; color: #065f46; }
.tag-sky     { background: #f0f9ff; color: #075985; }

.doc-kpi-sub {
    font-size: 11.5px;
    color: #64748b;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── Documents Table & Vault Card ──────────────────────────────────────── */
.docs-main-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);
    margin-bottom: 30px;
}

.docs-toolbar {
    padding: 18px 22px;
    border-bottom: 1px solid #f1f5f9;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
}

.docs-toolbar-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.docs-toolbar-title {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
}

.docs-count-badge {
    background: #eef2ff;
    color: #4f46e5;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 9999px;
}

.docs-toolbar-controls {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

/* View Mode Switcher */
.view-mode-toggle {
    display: flex;
    background: #f1f5f9;
    padding: 3px;
    border-radius: 8px;
    gap: 2px;
}

.view-mode-btn {
    background: transparent;
    border: none;
    padding: 5px 9px;
    border-radius: 6px;
    font-size: 13px;
    color: #64748b;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    align-items: center;
}

.view-mode-btn:hover {
    color: #0f172a;
}

.view-mode-btn.active {
    background: #ffffff;
    color: #4f46e5;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

/* Search Box */
.docs-search-box {
    position: relative;
    width: 230px;
}

.docs-search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #94a3b8;
    pointer-events: none;
}

.docs-search-input {
    width: 100%;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    padding-left: 30px;
    padding-right: 28px;
    font-size: 12.5px;
    background: #f8fafc;
    color: #0f172a;
    transition: all 0.2s ease;
}

.docs-search-input:focus {
    outline: none;
    background: #ffffff;
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.docs-search-clear {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 12px;
    color: #94a3b8;
    cursor: pointer;
    padding: 0;
}

/* ── Modern Table Styles ───────────────────────────────────────────────── */
.table-docs-custom {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    margin: 0;
}

.table-docs-custom thead {
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
}

.table-docs-custom th {
    padding: 13px 18px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #64748b;
    border: none;
    white-space: nowrap;
}

.table-docs-custom td {
    padding: 15px 18px;
    vertical-align: middle;
    border-bottom: 1px solid #f1f5f9;
    color: #334155;
}

.table-docs-custom tbody tr {
    transition: background-color 0.15s ease;
}

.table-docs-custom tbody tr:hover {
    background-color: #f8fafc;
}

.table-docs-custom tbody tr:last-child td {
    border-bottom: none;
}

.doc-title-cell {
    display: flex;
    align-items: center;
    gap: 12px;
}

.doc-file-icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: #fff1f2;
    color: #f43f5e;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
}

.doc-file-icon.icon-pdf {
    background: #fff1f2;
    color: #e11d48;
}

.doc-file-icon.icon-generic {
    background: #eef2ff;
    color: #4f46e5;
}

.doc-info-text {
    display: flex;
    flex-direction: column;
}

.doc-info-title {
    font-weight: 600;
    color: #0f172a;
    font-size: 13.5px;
}

.doc-info-filename {
    font-size: 11.5px;
    color: #94a3b8;
}

.doc-project-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #334155;
    white-space: nowrap;
}

.doc-project-badge i {
    color: #6366f1;
}

.doc-client-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #475569;
    font-size: 12.5px;
    font-weight: 500;
}

.doc-files-pills {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}

.btn-file-download {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 5px 12px;
    background: #ffffff;
    border: 1px solid #cbd5e1;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    color: #334155;
    text-decoration: none;
    transition: all 0.2s ease;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.btn-file-download:hover {
    background: #eef2ff;
    border-color: #a5b4fc;
    color: #4f46e5;
    transform: translateY(-1px);
}

.btn-file-download i {
    font-size: 13px;
    color: #e11d48;
}

/* ── Grid Card View ────────────────────────────────────────────────────── */
.docs-grid-view {
    padding: 20px;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
}

.doc-card-item {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    transition: all 0.2s ease;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.doc-card-item:hover {
    border-color: #cbd5e1;
    box-shadow: 0 8px 20px -4px rgba(15, 23, 42, 0.08);
    transform: translateY(-2px);
}

.doc-card-header {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 12px;
}

.doc-card-title {
    font-weight: 700;
    font-size: 14px;
    color: #0f172a;
    margin: 0 0 4px 0;
    line-height: 1.3;
}

.doc-card-meta {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 14px;
    font-size: 12px;
    color: #64748b;
}

.doc-card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 12px;
    border-top: 1px solid #f1f5f9;
}

/* ── Empty State ───────────────────────────────────────────────────────── */
.docs-empty-state {
    padding: 60px 20px;
    text-align: center;
    color: #64748b;
}

.docs-empty-icon-wrap {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    background: #f1f5f9;
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    margin: 0 auto 16px auto;
}

.docs-empty-title {
    font-size: 16px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
}

.docs-empty-desc {
    font-size: 13px;
    color: #94a3b8;
    max-width: 420px;
    margin: 0 auto 20px auto;
    line-height: 1.5;
}

/* ── Loading Skeleton ─────────────────────────────────────────────────── */
.docs-loading-wrap {
    padding: 60px 20px;
    text-align: center;
    color: #64748b;
}

.docs-spinner {
    width: 36px;
    height: 36px;
    border: 3px solid #e2e8f0;
    border-top-color: #4f46e5;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin: 0 auto 12px auto;
}

@keyframes spin {
    to { transform: rotate(360deg); }
}

/* ── Primary Hero Button ──────────────────────────────────────────────── */
.btn-docs-primary {
    background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%) !important;
    color: #ffffff !important;
    border: none !important;
    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25) !important;
    transition: all 0.2s ease !important;
}

.btn-docs-primary:hover {
    background: linear-gradient(135deg, #4338ca 0%, #4f46e5 100%) !important;
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(79, 70, 229, 0.35) !important;
    color: #ffffff !important;
}

.btn-docs-primary i {
    font-size: 14px;
}

/* ── Modal Customization ──────────────────────────────────────────────── */
.docs-custom-modal .modal-content {
    border: none;
    border-radius: 16px;
    box-shadow: 0 20px 40px -8px rgba(15, 23, 42, 0.2);
    overflow: hidden;
}

.docs-custom-modal .modal-header {
    background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
    padding: 18px 24px;
}

.docs-modal-title {
    font-size: 17px;
    font-weight: 700;
    color: #0f172a;
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0;
}

.docs-modal-title-icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    background: #eef2ff;
    color: #4f46e5;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
}

.docs-custom-modal .modal-body {
    padding: 24px;
}

.docs-custom-modal .modal-footer {
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
    padding: 14px 24px;
}

/* Form inputs in Modal */
.docs-form-group {
    margin-bottom: 18px;
}

.docs-form-label {
    display: block;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #475569;
    margin-bottom: 6px;
}

.docs-form-label .req {
    color: #ef4444;
    margin-left: 2px;
}

.docs-form-control,
.docs-form-select {
    width: 100%;
    height: 42px;
    padding: 8px 14px;
    font-size: 13px;
    color: #1e293b;
    background: #ffffff;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    outline: none;
    transition: all 0.2s ease;
}

.docs-form-control:focus,
.docs-form-select:focus {
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
}

.docs-form-error {
    font-size: 12px;
    color: #ef4444;
    margin-top: 4px;
    display: flex;
    align-items: center;
    gap: 4px;
}

/* Dropzone */
.docs-dropzone {
    border: 2px dashed #cbd5e1;
    border-radius: 12px;
    background: #f8fafc;
    padding: 28px 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.docs-dropzone.dragging,
.docs-dropzone:hover {
    border-color: #6366f1;
    background: #eef2ff;
}

.docs-dropzone-icon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: #ffffff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    color: #6366f1;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 12px auto;
}

.docs-dropzone-title {
    font-size: 13px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 4px;
}

.docs-dropzone-title span {
    color: #4f46e5;
    text-decoration: underline;
}

.docs-dropzone-sub {
    font-size: 11px;
    color: #64748b;
}

/* Selected Files preview list */
.docs-selected-files-list {
    margin-top: 14px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 180px;
    overflow-y: auto;
}

.docs-file-pill {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 12px;
}

.docs-file-pill-left {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.docs-file-pill-name {
    font-weight: 600;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 260px;
}

.docs-file-pill-size {
    color: #64748b;
    font-size: 11px;
}

.btn-remove-file-pill {
    background: transparent;
    border: none;
    color: #94a3b8;
    cursor: pointer;
    padding: 2px 6px;
    border-radius: 4px;
    transition: color 0.2s;
}

.btn-remove-file-pill:hover {
    color: #ef4444;
}

/* Delete Action Button */
.btn-doc-delete {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #fee2e2;
    background: #fff;
    color: #ef4444;
    cursor: pointer;
    transition: all 0.2s ease;
    margin-left: 6px;
}

.btn-doc-delete:hover {
    background: #ef4444;
    color: #ffffff;
    border-color: #ef4444;
    box-shadow: 0 2px 6px rgba(239, 68, 68, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/pages/Documents.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E,6EAA6E;AAC7E;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iDAAiD;IACjD,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,mDAAmD;IACnD,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;AACzD,oBAAoB,mBAAmB,EAAE,cAAc,EAAE;;AAEzD;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;;AAEpD;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,6EAA6E;AAC7E;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,iDAAiD;IACjD,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yCAAyC;AAC7C;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA,6EAA6E;AAC7E;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,qBAAqB;IACrB,kDAAkD;IAClD,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA,6EAA6E;AAC7E;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA,4EAA4E;AAC5E;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,oCAAoC;IACpC,wBAAwB;AAC5B;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA,4EAA4E;AAC5E;IACI,wEAAwE;IACxE,yBAAyB;IACzB,uBAAuB;IACvB,yDAAyD;IACzD,oCAAoC;AACxC;;AAEA;IACI,wEAAwE;IACxE,2BAA2B;IAC3B,yDAAyD;IACzD,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA,4EAA4E;AAC5E;IACI,YAAY;IACZ,mBAAmB;IACnB,kDAAkD;IAClD,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA,aAAa;AACb;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;;IAEI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,gCAAgC;AAChC;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,6CAA6C;AACjD","sourcesContent":["/* ==========================================================================\n   ENTERPRISE DOCUMENTS & FILE VAULT STYLING\n   Theme: Precision Clean SaaS (Linear / Stripe / Vercel style)\n   ========================================================================== */\n\n/* ── Hero / Overview Header ────────────────────────────────────────────── */\n.docs-hero-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 20px;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n}\n\n.docs-hero-left {\n    flex: 1;\n    min-width: 280px;\n}\n\n.docs-badge-tag {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: #eef2ff;\n    color: #4f46e5;\n    border: 1px solid #c7d2fe;\n    border-radius: 9999px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 8px;\n}\n\n.docs-hero-title {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 24px;\n    font-weight: 800;\n    color: #0f172a;\n    margin: 0 0 6px 0;\n    letter-spacing: -0.5px;\n}\n\n.docs-hero-subtitle {\n    font-size: 13px;\n    color: #64748b;\n    margin: 0 0 12px 0;\n    max-width: 600px;\n    line-height: 1.5;\n}\n\n.docs-meta-chips {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.docs-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 11px;\n    font-weight: 600;\n    color: #475569;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n\n.docs-chip i {\n    font-size: 12px;\n    color: #6366f1;\n}\n\n.docs-chip-secure {\n    background: #ecfdf5;\n    border-color: #a7f3d0;\n    color: #065f46;\n}\n\n/* ── Hero Actions ──────────────────────────────────────────────────────── */\n.docs-hero-actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.btn-docs-action {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 10px;\n    border: 1px solid #e2e8f0;\n    background: #ffffff;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.btn-docs-action:hover {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n    color: #0f172a;\n    transform: translateY(-1px);\n}\n\n/* ── Executive KPI Cards Grid ──────────────────────────────────────────── */\n.docs-kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.doc-kpi-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 16px;\n    padding: 18px 20px;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);\n    transition: all 0.25s ease;\n}\n\n.doc-kpi-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 24px -4px rgba(15, 23, 42, 0.08);\n    border-color: #cbd5e1;\n}\n\n.doc-kpi-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.doc-kpi-label {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    color: #64748b;\n}\n\n.doc-kpi-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n}\n\n.doc-icon-indigo  { background: #eef2ff; color: #4f46e5; }\n.doc-icon-rose    { background: #fff1f2; color: #f43f5e; }\n.doc-icon-emerald { background: #ecfdf5; color: #10b981; }\n.doc-icon-sky     { background: #f0f9ff; color: #0284c7; }\n\n.doc-kpi-main {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.doc-kpi-val {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 24px;\n    font-weight: 800;\n    color: #0f172a;\n    line-height: 1.1;\n}\n\n.doc-kpi-tag {\n    font-size: 11px;\n    font-weight: 700;\n    padding: 2px 7px;\n    border-radius: 6px;\n}\n\n.tag-indigo  { background: #eef2ff; color: #3730a3; }\n.tag-rose    { background: #fff1f2; color: #9f1239; }\n.tag-emerald { background: #ecfdf5; color: #065f46; }\n.tag-sky     { background: #f0f9ff; color: #075985; }\n\n.doc-kpi-sub {\n    font-size: 11.5px;\n    color: #64748b;\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* ── Documents Table & Vault Card ──────────────────────────────────────── */\n.docs-main-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 16px;\n    overflow: hidden;\n    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);\n    margin-bottom: 30px;\n}\n\n.docs-toolbar {\n    padding: 18px 22px;\n    border-bottom: 1px solid #f1f5f9;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 14px;\n}\n\n.docs-toolbar-left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.docs-toolbar-title {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 16px;\n    font-weight: 700;\n    color: #0f172a;\n    margin: 0;\n}\n\n.docs-count-badge {\n    background: #eef2ff;\n    color: #4f46e5;\n    font-size: 11px;\n    font-weight: 700;\n    padding: 2px 8px;\n    border-radius: 9999px;\n}\n\n.docs-toolbar-controls {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n/* View Mode Switcher */\n.view-mode-toggle {\n    display: flex;\n    background: #f1f5f9;\n    padding: 3px;\n    border-radius: 8px;\n    gap: 2px;\n}\n\n.view-mode-btn {\n    background: transparent;\n    border: none;\n    padding: 5px 9px;\n    border-radius: 6px;\n    font-size: 13px;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    display: flex;\n    align-items: center;\n}\n\n.view-mode-btn:hover {\n    color: #0f172a;\n}\n\n.view-mode-btn.active {\n    background: #ffffff;\n    color: #4f46e5;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n/* Search Box */\n.docs-search-box {\n    position: relative;\n    width: 230px;\n}\n\n.docs-search-icon {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 12px;\n    color: #94a3b8;\n    pointer-events: none;\n}\n\n.docs-search-input {\n    width: 100%;\n    height: 34px;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n    padding-left: 30px;\n    padding-right: 28px;\n    font-size: 12.5px;\n    background: #f8fafc;\n    color: #0f172a;\n    transition: all 0.2s ease;\n}\n\n.docs-search-input:focus {\n    outline: none;\n    background: #ffffff;\n    border-color: #6366f1;\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);\n}\n\n.docs-search-clear {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    font-size: 12px;\n    color: #94a3b8;\n    cursor: pointer;\n    padding: 0;\n}\n\n/* ── Modern Table Styles ───────────────────────────────────────────────── */\n.table-docs-custom {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 13px;\n    margin: 0;\n}\n\n.table-docs-custom thead {\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.table-docs-custom th {\n    padding: 13px 18px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: #64748b;\n    border: none;\n    white-space: nowrap;\n}\n\n.table-docs-custom td {\n    padding: 15px 18px;\n    vertical-align: middle;\n    border-bottom: 1px solid #f1f5f9;\n    color: #334155;\n}\n\n.table-docs-custom tbody tr {\n    transition: background-color 0.15s ease;\n}\n\n.table-docs-custom tbody tr:hover {\n    background-color: #f8fafc;\n}\n\n.table-docs-custom tbody tr:last-child td {\n    border-bottom: none;\n}\n\n.doc-title-cell {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.doc-file-icon {\n    width: 38px;\n    height: 38px;\n    border-radius: 10px;\n    background: #fff1f2;\n    color: #f43f5e;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    flex-shrink: 0;\n}\n\n.doc-file-icon.icon-pdf {\n    background: #fff1f2;\n    color: #e11d48;\n}\n\n.doc-file-icon.icon-generic {\n    background: #eef2ff;\n    color: #4f46e5;\n}\n\n.doc-info-text {\n    display: flex;\n    flex-direction: column;\n}\n\n.doc-info-title {\n    font-weight: 600;\n    color: #0f172a;\n    font-size: 13.5px;\n}\n\n.doc-info-filename {\n    font-size: 11.5px;\n    color: #94a3b8;\n}\n\n.doc-project-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: #f1f5f9;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #334155;\n    white-space: nowrap;\n}\n\n.doc-project-badge i {\n    color: #6366f1;\n}\n\n.doc-client-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: #475569;\n    font-size: 12.5px;\n    font-weight: 500;\n}\n\n.doc-files-pills {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: wrap;\n}\n\n.btn-file-download {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 5px 12px;\n    background: #ffffff;\n    border: 1px solid #cbd5e1;\n    border-radius: 8px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #334155;\n    text-decoration: none;\n    transition: all 0.2s ease;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n\n.btn-file-download:hover {\n    background: #eef2ff;\n    border-color: #a5b4fc;\n    color: #4f46e5;\n    transform: translateY(-1px);\n}\n\n.btn-file-download i {\n    font-size: 13px;\n    color: #e11d48;\n}\n\n/* ── Grid Card View ────────────────────────────────────────────────────── */\n.docs-grid-view {\n    padding: 20px;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n    gap: 16px;\n}\n\n.doc-card-item {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    transition: all 0.2s ease;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);\n}\n\n.doc-card-item:hover {\n    border-color: #cbd5e1;\n    box-shadow: 0 8px 20px -4px rgba(15, 23, 42, 0.08);\n    transform: translateY(-2px);\n}\n\n.doc-card-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    margin-bottom: 12px;\n}\n\n.doc-card-title {\n    font-weight: 700;\n    font-size: 14px;\n    color: #0f172a;\n    margin: 0 0 4px 0;\n    line-height: 1.3;\n}\n\n.doc-card-meta {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin-bottom: 14px;\n    font-size: 12px;\n    color: #64748b;\n}\n\n.doc-card-footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-top: 12px;\n    border-top: 1px solid #f1f5f9;\n}\n\n/* ── Empty State ───────────────────────────────────────────────────────── */\n.docs-empty-state {\n    padding: 60px 20px;\n    text-align: center;\n    color: #64748b;\n}\n\n.docs-empty-icon-wrap {\n    width: 64px;\n    height: 64px;\n    border-radius: 16px;\n    background: #f1f5f9;\n    color: #94a3b8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 28px;\n    margin: 0 auto 16px auto;\n}\n\n.docs-empty-title {\n    font-size: 16px;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 6px;\n}\n\n.docs-empty-desc {\n    font-size: 13px;\n    color: #94a3b8;\n    max-width: 420px;\n    margin: 0 auto 20px auto;\n    line-height: 1.5;\n}\n\n/* ── Loading Skeleton ─────────────────────────────────────────────────── */\n.docs-loading-wrap {\n    padding: 60px 20px;\n    text-align: center;\n    color: #64748b;\n}\n\n.docs-spinner {\n    width: 36px;\n    height: 36px;\n    border: 3px solid #e2e8f0;\n    border-top-color: #4f46e5;\n    border-radius: 50%;\n    animation: spin 0.8s linear infinite;\n    margin: 0 auto 12px auto;\n}\n\n@keyframes spin {\n    to { transform: rotate(360deg); }\n}\n\n/* ── Primary Hero Button ──────────────────────────────────────────────── */\n.btn-docs-primary {\n    background: linear-gradient(135deg, #4f46e5 0%, #6366f1 100%) !important;\n    color: #ffffff !important;\n    border: none !important;\n    box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25) !important;\n    transition: all 0.2s ease !important;\n}\n\n.btn-docs-primary:hover {\n    background: linear-gradient(135deg, #4338ca 0%, #4f46e5 100%) !important;\n    transform: translateY(-1px);\n    box-shadow: 0 6px 16px rgba(79, 70, 229, 0.35) !important;\n    color: #ffffff !important;\n}\n\n.btn-docs-primary i {\n    font-size: 14px;\n}\n\n/* ── Modal Customization ──────────────────────────────────────────────── */\n.docs-custom-modal .modal-content {\n    border: none;\n    border-radius: 16px;\n    box-shadow: 0 20px 40px -8px rgba(15, 23, 42, 0.2);\n    overflow: hidden;\n}\n\n.docs-custom-modal .modal-header {\n    background: #f8fafc;\n    border-bottom: 1px solid #e2e8f0;\n    padding: 18px 24px;\n}\n\n.docs-modal-title {\n    font-size: 17px;\n    font-weight: 700;\n    color: #0f172a;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin: 0;\n}\n\n.docs-modal-title-icon {\n    width: 34px;\n    height: 34px;\n    border-radius: 10px;\n    background: #eef2ff;\n    color: #4f46e5;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n}\n\n.docs-custom-modal .modal-body {\n    padding: 24px;\n}\n\n.docs-custom-modal .modal-footer {\n    background: #f8fafc;\n    border-top: 1px solid #e2e8f0;\n    padding: 14px 24px;\n}\n\n/* Form inputs in Modal */\n.docs-form-group {\n    margin-bottom: 18px;\n}\n\n.docs-form-label {\n    display: block;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: #475569;\n    margin-bottom: 6px;\n}\n\n.docs-form-label .req {\n    color: #ef4444;\n    margin-left: 2px;\n}\n\n.docs-form-control,\n.docs-form-select {\n    width: 100%;\n    height: 42px;\n    padding: 8px 14px;\n    font-size: 13px;\n    color: #1e293b;\n    background: #ffffff;\n    border: 1px solid #cbd5e1;\n    border-radius: 10px;\n    outline: none;\n    transition: all 0.2s ease;\n}\n\n.docs-form-control:focus,\n.docs-form-select:focus {\n    border-color: #6366f1;\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);\n}\n\n.docs-form-error {\n    font-size: 12px;\n    color: #ef4444;\n    margin-top: 4px;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n/* Dropzone */\n.docs-dropzone {\n    border: 2px dashed #cbd5e1;\n    border-radius: 12px;\n    background: #f8fafc;\n    padding: 28px 20px;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.docs-dropzone.dragging,\n.docs-dropzone:hover {\n    border-color: #6366f1;\n    background: #eef2ff;\n}\n\n.docs-dropzone-icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background: #ffffff;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n    color: #6366f1;\n    font-size: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto 12px auto;\n}\n\n.docs-dropzone-title {\n    font-size: 13px;\n    font-weight: 600;\n    color: #1e293b;\n    margin-bottom: 4px;\n}\n\n.docs-dropzone-title span {\n    color: #4f46e5;\n    text-decoration: underline;\n}\n\n.docs-dropzone-sub {\n    font-size: 11px;\n    color: #64748b;\n}\n\n/* Selected Files preview list */\n.docs-selected-files-list {\n    margin-top: 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    max-height: 180px;\n    overflow-y: auto;\n}\n\n.docs-file-pill {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 12px;\n    background: #f1f5f9;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 12px;\n}\n\n.docs-file-pill-left {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-width: 0;\n}\n\n.docs-file-pill-name {\n    font-weight: 600;\n    color: #1e293b;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 260px;\n}\n\n.docs-file-pill-size {\n    color: #64748b;\n    font-size: 11px;\n}\n\n.btn-remove-file-pill {\n    background: transparent;\n    border: none;\n    color: #94a3b8;\n    cursor: pointer;\n    padding: 2px 6px;\n    border-radius: 4px;\n    transition: color 0.2s;\n}\n\n.btn-remove-file-pill:hover {\n    color: #ef4444;\n}\n\n/* Delete Action Button */\n.btn-doc-delete {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: 1px solid #fee2e2;\n    background: #fff;\n    color: #ef4444;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    margin-left: 6px;\n}\n\n.btn-doc-delete:hover {\n    background: #ef4444;\n    color: #ffffff;\n    border-color: #ef4444;\n    box-shadow: 0 2px 6px rgba(239, 68, 68, 0.25);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
